import React from 'react';
import showToast from '@/components/common/Toast';
import Text from '@/components/ui/Text';
import useTeacherPacedModeOptInMutation from './useTeacherPacedModeOptInMutation';

interface TeacherPacedModeOptInProps {
  isTeacherPacedModeActive: boolean;
  setIsTeacherPacedModeActive: (nextState: boolean) => void;
  stafferPath: string;
}

const DisabledDescription = () => (
  <Text size="sm">
    Teacher-Paced Mode lets you take control of your class&apos;s slideshow experience. Start a live
    session and your students automatically follow along — no independent clicking ahead. You control
    the pace, they stay in sync.
  </Text>
);

const EnabledDescription = () => (
  <Text size="sm">
    Teacher-Paced Mode is on. You can start a live session from any slideshow&apos;s present mode.
    Students will be locked to your current slide until you end the session.
  </Text>
);

const TeacherPacedModeOptIn = ({
  isTeacherPacedModeActive,
  setIsTeacherPacedModeActive,
  stafferPath,
}: TeacherPacedModeOptInProps) => {
  const { mutate, isLoading } = useTeacherPacedModeOptInMutation({ stafferPath });

  const handleOptInOut = () => {
    const nextState = !isTeacherPacedModeActive;

    mutate({ nextSetting: nextState }, {
      onSuccess: () => {
        showToast(`You have successfully opted ${nextState ? 'in' : 'out'}`, { position: 'bottom-right' });
        setIsTeacherPacedModeActive(nextState);
      },
    });
  };

  return (
    <div className="tw-pt-6">
      <Text className="tw-mb-4" variant="heading5">
        Teacher-Paced Mode: Lead your class through slides together
      </Text>
      <div className="tw-flex tw-items-start tw-justify-between">
        <div className="tw-w-4/5 tw-min-h-[4.5rem]">
          {isTeacherPacedModeActive ? <EnabledDescription /> : <DisabledDescription />}
        </div>
        <button
          className="btn btn--purple"
          disabled={isLoading}
          type="button"
          onClick={handleOptInOut}
        >
          {isTeacherPacedModeActive ? 'Opt Out' : 'Opt In'}
        </button>
      </div>
    </div>
  );
};

export default TeacherPacedModeOptIn;
